import React, { useState, useEffect } from "react";
import {
  ChatAltIcon,
  UserRemoveIcon,
  XIcon,
  CheckIcon,
  PlusCircleIcon,
  PlusIcon,
} from "@heroicons/react/solid";
import { MenuIcon } from "@heroicons/react/outline"; // Added
import "./Friends.css";
import axios from "axios";
import backendService from "../services.js/backendService";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import { ToastContainer, toast } from "react-toastify";
import SearchUser from "./SearchUser";
import toastProp from "../global/toastProps";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "react-query";
import ReactTooltip from "react-tooltip";

function QuipComponent() {
  return Array.apply(null, { length: 5 }).map((e, i) => (
    <ShimmerCategoryItem
      key={i}
      hasImage
      imageType="circular"
      imageWidth={56}
      imageHeight={56}
      contentCenter
      text
    />
  ));
}
const Friend = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_URL}/getfriends`, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": backendService.getToken(),
      },
    });

    return res.data.friends;
  } catch (error) {
    return error.response;
  }
};
const FriendRequests = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_URL}/getfriendrequests`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      }
    );
    return res.data.friendRequests;
  } catch (error) {
    return error.response;
  }
};
function Friends(props) {
  const [friends, setFriends] = useState(true);
  const [searchTabOpen, setSearchTabOpen] = useState(false);
  const [requests, setRequests] = useState(false);
  const [friendsData, setFriendsData] = useState([]);
  const [friendsDataLoading, setFriendsDataLoading] = useState(true);
  const [requestsData, setRequestsData] = useState([]);
  const [requestsDataLoading, setRequestsDataLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const { data, status, refetch } = useQuery("friends", Friend, {
    retry: true,
  });
  const {
    data: requestData,
    status: statusRequest,
    refetch: refetchRequest,
  } = useQuery("friendRequest", FriendRequests, {
    retry: true,
  });
  useEffect(() => {
    if (status === "success") {
      setFriendsData(data);
      setFriendsDataLoading(false);
    }
  }, [data, status, friendsData]);
  useEffect(() => {
    if (statusRequest === "success") {
      setRequestsData(requestData);
      setRequestsDataLoading(false);
    }
  }, [requestData, statusRequest, requests]);
  const handleFriends = async () => {
    refetch();
  };

  const handleFriendRequests = async () => {
    refetchRequest();
  };

  const handleAcceptFriendRequest = async (friendId) => {
    const id = toast.loading("Please wait ...", { theme: "light" });
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/acceptfriend`,
        {
          friendId: friendId,
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      handleFriendRequests();
      handleFriends();
      setLoading(false);
      toast.update(id, toastProp("Friend Added ...", true));
    } catch (error) {
      console.log(error);
      toast.update(id, toastProp("Something went wrong ...", false));
    }
  };

  const handleDeleteFriendRequest = async (friendId) => {
    const id = toast.loading("Please wait ...", { theme: "light" });
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/cancelfriendrequest`,
        {
          friendId: friendId,
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      toast.update(id, toastProp("Friend Request Cancelled ...", true));
      handleFriendRequests();
      handleFriends();
      setLoading(false);
    } catch (error) {
      toast.update(id, toastProp("Something went wrong ...", false));
      console.log(error);
    }
  };
  const handleDeleteFriend = async (friendId) => {
    const id = toast.loading("Please wait ...", { theme: "light" });
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/removefriend`,
        {
          friendId: friendId,
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      toast.update(id, toastProp("Friend Removed ...", true));
      handleFriends();
      setLoading(false);
    } catch (error) {
      toast.update(id, toastProp("Something went wrong ...", false));
      console.log(error);
    }
  };

  const handleCreateConversation = async (friendId) => {
    const id = toast.loading("Please wait ...", { theme: "light" });
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/createconversation`,
        {
          friendId: friendId,
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setLoading(false);
      toast.update(id, toastProp("Conversation Channel Created ...", true));
      handleFriends();
    } catch (error) {
      toast.update(id, toastProp(error.response.data["Status"], false));
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col w-full h-screen select-none bg-background"> {/* Added flex flex-col */}
      {/* New Header */}
      <div className="h-[60px] bg-background flex items-center px-3 sm:px-5 border-b border-palette_color1">
        {props.setIsMobileMenuOpen && (
            <div className="mr-3 sm:hidden">
              <button onClick={() => props.setIsMobileMenuOpen(!props.isMobileMenuOpen)} className="p-1 text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                {props.isMobileMenuOpen ? <XIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
              </button>
            </div>
         )}
        <h3 className="flex-grow min-w-0 overflow-hidden text-xl text-primary sm:text-2xl font-robo whitespace-nowrap text-ellipsis">Friends</h3>
        {/* Placeholder for potential future icons like Add Friend if tabs are reworked */}
      </div>
      {/* Tab Bar */}
      <ReactTooltip delayShow={500} delayHide={100} />
      <div className="flex border-b cursor-pointer border-palette_color1"> {/* Removed h-[8%] */}
        <div
          className={`${
            friends
              ? "w-[33.33%]  flex justify-center items-center hover:opacity-70  select-none active:opacity-40 bg-palette_color2 text-primary "
              : "w-[33.33%]  flex justify-center items-center hover:opacity-70  select-none active:opacity-40 bg-palette_color1 text-white  subpixel-antialiased"
          }`}
          onClick={() => {
            setFriends(true);
            setRequests(false);
            setSearchTabOpen(false);
          }}
        >
          <h3
            className="text-lg  font-robo"
            data-tip="Friends"
            data-place="bottom"
          >
            Friends
          </h3>
        </div>
        <div
          className={`${
            requests
              ? "w-[33.33%] flex justify-center items-center hover:opacity-70 select-none  active:opacity-40 bg-palette_color2 text-primary"
              : "w-[33.33%] flex justify-center items-center hover:opacity-70 select-none active:opacity-40 bg-palette_color1 text-white subpixel-antialiased"
          }`}
          onClick={() => {
            setFriends(false);
            setRequests(true);
            setSearchTabOpen(false);
          }}
        >
          <div className="flex justify-center   items-center w-[100%]">
            <h3
              className="text-lg font-robo "
              data-tip="Requests"
              data-place="bottom"
            >
              Requests
            </h3>
            {requestsData.length > 0 ? (
              <div className="flex items-center justify-center w-5 h-5 ml-1 bg-green-500 rounded-full">
                <h3 className="text-lg font-proxima">{requestsData.length}</h3>
              </div>
            ) : null}
          </div>
        </div>
        <div
          className={`${
            searchTabOpen
              ? "w-[33.33%] flex justify-center items-center hover:opacity-70 select-none  active:opacity-40 bg-palette_color2 text-primary"
              : "w-[33.33%] flex justify-center items-center hover:opacity-70 select-none active:opacity-40 bg-palette_color1 text-white  subpixel-antialiased"
          }`}
          onClick={() => {
            setFriends(false);
            setRequests(false);
            setSearchTabOpen(true);
          }}
        >
          <div className="flex items-center justify-around w-full">
            <h3
              className="text-lg text-center font-robo "
              data-tip="Requests"
              data-place="bottom"
            >
              Add Friends
            </h3>
          </div>
        </div>
      </div>
      {/* Rows */}
      {friends ? (
        //Friends
        <div className="flex-1 overflow-x-hidden overflow-y-auto scroll-smooth row_Overflow"> {/* Changed h-[90%] to flex-1 */}
          {!friendsDataLoading ? (
            friendsData.length > 0 ? (
              friendsData.map((friend) => (
                <div
                  aria-disabled={loading}
                  key={friend._id}
                  className="flex items-center p-3 m-1 transition-colors duration-150 bg-white border-b border-gray-200 cursor-pointer sm:p-4 sm:m-2 sm:rounded-lg hover:bg-gray-50 sm:border-none sm:shadow-sm"
                  onClick={() => {
                    if (!loading) {
                      if (friend.conversationId) {
                        props.getCurrent({
                          _id: friend.conversationId,
                          participants: [
                            {
                              firstname: friend.firstname,
                              lastname: friend.lastname,
                              username: friend.username,
                              _id: friend._id,
                              profilePicture: {
                                filePath: friend.profilePicture,
                              },
                            },
                          ],
                          notificationState: friend.notificationState,
                        });
                      }
                    }
                  }}
                >
                  <div className="flex items-center justify-center flex-none w-12 h-12 mr-3 sm:w-10 sm:h-10 sm:mr-4">
                    <div className="items-center justify-center ">
                      <img
                        alt="Profile"
                        className="rounded-full h-[40px] w-[40px] cursor-pointer"
                        src={
                          friend?.profilePicture
                            ? friend.profilePicture
                            : require("../assets/boredApe.png")
                        }
                      />
                    </div>
                  </div>
                  <div className="flex-grow min-w-0">
                    <h3 className="text-sm font-semibold text-gray-800 truncate sm:text-md">{friend?.firstname + " " + friend?.lastname}</h3>
                    <p className="text-xs text-gray-500 truncate">{"@" + friend?.username}</p>
                  </div>
                  <div className="flex items-center flex-none ml-2 space-x-2 sm:space-x-3 sm:ml-3">
                        <div
                          className="flex items-center justify-center h-7 w-7" // Removed hover classes, will be on icon
                            title={
                              friend?.conversationId
                                ? "Open Conversation"
                                : "Create Conversation"
                            }
                          >
                            {friend?.conversationId ? (
                              <ChatAltIcon
                                className="w-6 h-6 text-gray-400 cursor-pointer hover:text-palette_color1"
                                aria-hidden="true"
                                aria-disabled={loading}
                                onClick={() => {
                                  if (!loading) {
                                    props.getCurrent({
                                      _id: friend.conversationId,
                                      participants: [
                                        {
                                          firstname: friend.firstname,
                                          lastname: friend.lastname,
                                          profilePicture: {
                                            filePath: friend.profilePicture,
                                          },
                                        },
                                      ],
                                    });
                                  }
                                }}
                              />
                            ) : (
                              <PlusIcon
                                className="w-6 h-6 antialiased text-gray-400 cursor-pointer hover:text-palette_color1"
                                aria-hidden="true"
                                aria-disabled={loading}
                                onClick={() => {
                                  if (!loading) {
                                    handleCreateConversation(friend._id);
                                  }
                                }}
                              />
                            )}
                          </div>
                          <div
                            className="flex items-center justify-center h-7 w-7" // Removed hover classes, will be on icon
                            title="Remove Friend"
                          >
                            <XIcon
                              aria-disabled={loading}
                              className="w-6 h-6 text-gray-400 cursor-pointer hover:text-red-500"
                              aria-hidden="true"
                              onClick={() => {
                                if (!loading) {
                                  handleDeleteFriend(friend._id);
                                }
                              }}
                            />
                          </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center">
                <p className="mt-10 text-lg text-palette_color1 font-robo">
                  No Friends Added Yet :(
                </p>
                {/* <button
                  className=" bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                  type="button"
                  onClick={async () => props.openSearchUser(true)}
                >
                  Add Friends
                </button> */}
              </div>
            )
          ) : (
            <div className="pl-4">
              {" "}
              <QuipComponent />
            </div>
          )}
        </div>
      ) : requests ? (
        //Requests
        <div className="overflow-x-hidden overflow-y-auto rounded-lg  scroll-smooth row_Overflow">
          {!requestsDataLoading ? (
            requestsData.length > 0 ? (
              requestsData.map((request) => (
                <div
                  key={request?._id}
                  className="flex items-center p-3 m-1 transition-colors duration-150 bg-white border-b border-gray-200 cursor-default sm:p-4 sm:m-2 sm:rounded-lg hover:bg-gray-50 sm:border-none sm:shadow-sm"
                >
                  <div className="flex items-center justify-center flex-none w-12 h-12 mr-3 sm:w-10 sm:h-10 sm:mr-4">
                    <div className="">
                      <img
                        alt="Profile"
                        className="rounded-full h-[40px] w-[40px] cursor-pointer"
                        src={
                          request?.profilePicture
                            ? request?.profilePicture?.filePath
                            : require("../assets/boredApe.png")
                        }
                      />
                    </div>
                  </div>
                  <div className="flex-grow min-w-0">
                    <h3 className="text-sm font-semibold text-gray-800 truncate sm:text-md">{request?.firstname + " " + request?.lastname}</h3>
                    <p className="text-xs text-gray-500 truncate">{"@" + request?.username}</p>
                  </div>
                  <div className="flex items-center flex-none ml-2 space-x-2 sm:space-x-3 sm:ml-3">
                          <div
                            className="flex items-center justify-center h-7 w-7" // Removed hover classes
                            title="Accept"
                          >
                            <CheckIcon
                              aria-disabled={loading}
                              className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-600 sm:h-7 sm:w-7"
                              aria-hidden="true"
                              onClick={() => {
                                if (!loading) {
                                  handleAcceptFriendRequest(request._id);
                                }
                              }}
                            />
                          </div>
                          <div
                            className="flex items-center justify-center h-7 w-7" // Removed hover classes
                            title="Decline"
                          >
                            <XIcon
                              aria-disabled={loading}
                              className="w-6 h-6 text-red-500 cursor-pointer hover:text-red-600 sm:h-7 sm:w-7"
                              aria-hidden="true"
                              onClick={() => {
                                if (!loading) {
                                  handleDeleteFriendRequest(request._id);
                                }
                              }}
                            />
                          </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex items-center justify-center">
                <p className="mt-10 text-lg text-palette_color1 font-robo">
                  No Requests Yet
                </p>
              </div>
            )
          ) : (
            <div className="pl-4">
              {" "}
              <QuipComponent />
            </div>
          )}
        </div>
      ) : (
        <SearchUser />
      )}
    </div>
  );
}

export default Friends;
